import { out } from "@/lib/output/out";
/** Sanitised first: transcript text is model, tool and repository output. */
export function truncate(text: string, max = 2000): string {
  const trimmed = out.safe(text).trim();
  return trimmed.length > max ? `${trimmed.slice(0, max)}…` : trimmed;
}
